import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { ToggleRow } from './toggle-row';
import { Typography } from '@usepepper/sprout-kit-ui';
import { View } from 'react-native';

interface EmployeeAccessSectionProps {
  adminPending: boolean;
  isAdmin: boolean;
  onAdminChange: (isAdminRole: boolean) => void;
  onShowPaymentsChange: (nextShowAppPayments: boolean) => void;
  showAppPayments: boolean;
  showPaymentsPending: boolean;
}

export const EmployeeAccessSection: React.FC<EmployeeAccessSectionProps> = ({
  adminPending,
  isAdmin,
  onAdminChange,
  onShowPaymentsChange,
  showAppPayments,
  showPaymentsPending,
}) => {
  const [styles] = useStyles();

  return (
    <View style={styles.container}>
      <Typography accessibilityRole="header" bold size="$md">
        {i18n.t('sales_portal.employee_edit_drawer.access.title')}
      </Typography>
      <View style={styles.rows}>
        <ToggleRow
          caption={i18n.t(
            'sales_portal.employee_edit_drawer.access.admin_subtitle',
          )}
          checked={isAdmin}
          disabled={adminPending}
          onCheckedChange={onAdminChange}
          title={i18n.t('sales_portal.employee_edit_drawer.access.admin_title')}
        />
        <ToggleRow
          checked={showAppPayments}
          disabled={showPaymentsPending}
          onCheckedChange={onShowPaymentsChange}
          title={i18n.t(
            'sales_portal.employee_edit_drawer.access.in_app_payments_title',
          )}
        />
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    gap: theme.sk.spacing.spaceMedium,
    width: '100%',
  },
  rows: {
    gap: theme.sk.spacing.spaceSMedium,
  },
}));
